import { render, staticRenderFns } from "./SellerInformationComp.vue?vue&type=template&id=56b08556&scoped=true"
import script from "./SellerInformationComp.vue?vue&type=script&lang=js"
export * from "./SellerInformationComp.vue?vue&type=script&lang=js"
import style0 from "./SellerInformationComp.vue?vue&type=style&index=0&id=56b08556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b08556",
  null
  
)

export default component.exports